import baseHttp from './baseHttp';

export const getBusinessHours = (restaurantId) =>
  baseHttp.get(`/api/v1/business-hours/restaurants/${restaurantId}`).then((r) => r.data);

export const updateBusinessHours = (restaurantId, days) =>
  baseHttp.put(`/api/v1/business-hours/${restaurantId}`, { days }).then((r) => r.data);

export const toggleDay = (restaurantId, day) =>
  baseHttp.put(`/api/v1/business-hours/${restaurantId}/toggle`, { day }).then((r) => r.data);
